import { useContext } from 'react';
import { RemContext } from '../context/rem/RemProvider';
import { Dimensions, Platform } from 'react-native';
const SCREEN_WIDTH = Math.min(Dimensions.get('window').width, Dimensions.get('window').height);
export function useRem(isScalable) {
    const { factor, scalable } = useContext(RemContext);
    const mergeScalable = typeof isScalable === 'boolean' ? isScalable : scalable;
    const scalableDisable = Platform.OS === 'web' || !mergeScalable;
    return (num) => {
        return scalableDisable
            ? num
            : Number(((SCREEN_WIDTH / factor) * num).toFixed(1));
    };
}
